
export type Pedigrees$ParentType = 'DAM' | 'SIRE'
export class Pedigrees$ParentTypeValues {
static readonly   DAM: Pedigrees$ParentType = 'DAM';
static readonly   SIRE: Pedigrees$ParentType = 'SIRE';
};

